import React from "react";
import Button from "@Components/Button";
import StepNumber from "@Components/Icons/StepNumber";
import Tick from "@Components/Icons/Tick";
import { Sections } from "@Shared/Entities/Customer/Tender/enums";
import PredictMascotIcon from "@Components/Icons/PredictMascot";
import { usagePercentageTarget } from "@SmartComponents/TenderEdit";
import styles from "./index.module.scss";
export default class SubHeader extends React.Component {
    getSectionName = (section) => {
        switch (section) {
            case Sections.LineRequirements:
                return "Line Requirement";
            case Sections.ContractEndDates:
                return "Contract end dates";
            case Sections.CurrentCostsOrDiscountsAndBenefits:
                if (this.props.hasUsage) {
                    return "Discounts & Benefits";
                }
                return "Current costs";
            case Sections.DataInternationalCallsAndRoaming:
                return "Data, international calls & roaming";
            case Sections.NetworkProviderOptions:
                return "Network provider options";
            case Sections.HandsetsAndDevicesOptions:
                return "Handsets & Devices";
            case Sections.MDM:
                return "Mobile device management";
            case Sections.AdditionalInfo:
                return "Additional information";
            default:
                return "";
        }
    };
    getActiveStep = () => {
        const sections = [
            Sections.LineRequirements,
            Sections.ContractEndDates,
            Sections.CurrentCostsOrDiscountsAndBenefits,
            Sections.DataInternationalCallsAndRoaming,
            Sections.NetworkProviderOptions,
            Sections.HandsetsAndDevicesOptions,
            Sections.MDM,
            Sections.AdditionalInfo,
        ];
        const { openSections = {} } = this.props;
        const sectionsArray = Object.keys(openSections)
            .map(Number)
            .sort((a, b) => a - b);
        const currentOpenSection = sectionsArray.find((section) => openSections[section]);
        if (currentOpenSection !== undefined) {
            const index = sections.indexOf(currentOpenSection);
            if (index === -1) {
                return sections.length;
            }
            return index + 1;
        }
        // If no section is open, find first incomplete section
        for (const [index, sectionValue] of sections.entries()) {
            if (this.props.completedSections[sectionValue] === undefined ||
                this.props.completedSections[sectionValue] === false) {
                return index + 1;
            }
        }
        return sections.length;
    };
    displayPublishButton = (allComplete) => {
        const { hasUsage = false, published = false, usagePercentage = 0, } = this.props;
        if (hasUsage && usagePercentage < usagePercentageTarget) {
            return (React.createElement(Button, { click: this.props.save, key: `button-${allComplete}`, cta: true }, "PUBLISH"));
        }
        if (!published) {
            return (React.createElement(Button, { click: this.props.publish, key: `button-${allComplete}`, cta: true }, "PUBLISH"));
        }
        return (React.createElement(Button, { click: this.props.publish, key: `button-${allComplete}`, cta: true }, "UPDATE"));
    };
    getTitle = () => {
        let title;
        let text;
        if (!this.props.hasUsage) {
            title = "Build your Tender";
            text = (React.createElement(React.Fragment, null, "Questions can be completed in any order and are saved as you go. Just a few minutes and you're finished!"));
        }
        else if (this.props.usagePercentage < usagePercentageTarget) {
            title = "Your savings prediction is on its way";
            text = (React.createElement(React.Fragment, null, "Information will start to populate the coloured boxes. The questions below only take a few minutes to complete."));
        }
        else {
            title = "Almost finished";
            text = (React.createElement(React.Fragment, null, "Please complete the questions and collect the remaining ticks, submit and publish your Tender to our expert panel of the UK's best independent suppliers. Your current supplier can be invited into the process after you have published."));
        }
        return { title, text };
    };
    displaySteps = () => {
        const sections = [
            Sections.LineRequirements,
            Sections.ContractEndDates,
            Sections.CurrentCostsOrDiscountsAndBenefits,
            Sections.DataInternationalCallsAndRoaming,
            Sections.NetworkProviderOptions,
            Sections.HandsetsAndDevicesOptions,
            Sections.MDM,
            Sections.AdditionalInfo,
        ];
        return sections.map((sectionValue, index) => {
            const stepNumber = index + 1;
            const complete = this.props.completedSections[sectionValue];
            return (React.createElement("div", { key: `${sectionValue}-${complete}`, className: styles.step, onClick: () => this.props.goToSection(sectionValue) },
                React.createElement("div", { className: styles.stepLines },
                    index > 0 && (React.createElement("div", { className: styles.stepLineLeft })),
                    index < sections.length - 1 && (React.createElement("div", { className: styles.stepLineRight }))),
                React.createElement("div", { className: styles.stepIcon }, complete ? (React.createElement("div", { className: styles.stepIconComplete },
                    React.createElement(Tick, { success: true, size: "20px" }))) : (React.createElement(StepNumber, { number: stepNumber }))),
                React.createElement("div", { className: styles.stepLabel }, this.getSectionName(sectionValue))));
        });
    };
    render() {
        const activeStep = this.getActiveStep();
        const totalSteps = 8;
        const { title, text } = this.getTitle();
        return (React.createElement("div", { className: styles.wrapper },
            React.createElement("div", { className: styles.leftSection },
                React.createElement("div", { className: styles.titleWrapper },
                    React.createElement("div", { className: styles.title }, title)),
                React.createElement("div", { className: styles.description }, text)),
            React.createElement("div", { className: styles.centerSection }, this.displaySteps()),
            React.createElement("div", { className: styles.rightSection },
                React.createElement("div", { className: styles.stepCounter },
                    "Step",
                    " ",
                    React.createElement("span", { className: styles.stepCounterActive }, activeStep),
                    "\u00A0of ",
                    totalSteps)),
            React.createElement(PredictMascotIcon, { className: styles.mascot })));
    }
}
